'use strict';

angular.module('app.entity.field', [
    'app.entity.service',
    'app.study-context',
    'ecrd',
    'ui.router',
]);
